import { ScrollLock } from './scrollLock';
import defaultStyles from '../styles/default.scss';
/* eslint-disable @typescript-eslint/no-explicit-any */
export class LinkScroll {
    // tslint:disable-next-line: variable-name
    private static _instance: LinkScroll;
    private _scrollLock: ScrollLock;
    private _baseElement: Element;
    private _floatElement: Element;
    private desktopMinWidth = parseInt(defaultStyles.breakpointDesktopMinWidth);
    private shouldRun = false;
    private heightDiff: number;
    private bufferHeight: number;
    private deltaMarginTop: number;

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    public setComponent(scrollLock: ScrollLock, baseElement: Element, floatElement: Element) {
        if (typeof window !== 'undefined') {
            // only run on client side
            this.cleanBinding();
            this._scrollLock = scrollLock;
            this._baseElement = baseElement;
            this._floatElement = floatElement;
            this.updateBinding();
        }
    }

    public destroy(): void {
        this.cleanBinding();
    }


    private updateBinding() {
        // init and bind view resize
        this.onResize();
        window.addEventListener('resize', this.onResize.bind(this));

        // init and bind scroll
        window.addEventListener('scroll', this.onScroll.bind(this));
    }

    private cleanBinding() {
        // clean all event binding
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('scroll', this.onScroll);
    }

    private onResize() {
        this.shouldRun = window.innerWidth >= this.desktopMinWidth &&
            this._baseElement.scrollHeight > this._floatElement.scrollHeight &&
            this._floatElement.scrollHeight >= window.innerHeight;
        if (this.shouldRun) {
            this.heightDiff = Math.ceil(this._baseElement.scrollHeight - this._floatElement.scrollHeight);
            this.bufferHeight = Math.ceil(this._floatElement.scrollHeight - window.innerHeight);
        } else {
            this.resetMargin();
        }
    }

    private onScroll() {
        // TODO: as content service, maybe find a general way to detect if currently scrollable or not
        // Usecase: basekModal will not apply scroll lock right now
        requestAnimationFrame(() => {
            if (this._scrollLock.isLocked)
                return;

            if (window.scrollY > this.bufferHeight) {
                if (window.scrollY + window.innerHeight <= this._baseElement.scrollHeight) {
                    this.deltaMarginTop = window.scrollY - this.bufferHeight;
                    this.floatElement.setAttribute('style', `margin-top: ${Math.ceil(this.deltaMarginTop)}px`);
                } else {
                    this.floatElement.setAttribute('style', `margin-top: ${Math.ceil(this.heightDiff)}px`);
                }
            } else {
                this.deltaMarginTop = 0;
                this.resetMargin();
            }
        });
    }

    private resetMargin() {
        this.deltaMarginTop = 0;
        this.floatElement.removeAttribute('style');
    }

    get baseElement() {
        return this._baseElement;
    }

    get floatElement() {
        return this._floatElement;
    }
}
